// app-modal.component.ts
import { Component, Input, Output, EventEmitter, OnInit, AfterViewInit ,Inject } from '@angular/core';
import { MysynchModalComponent } from '../mysynch-modal/mysynch-modal.component';
import {moment} from '../../../js/globals.js';
import _ from 'lodash';
import { ModalDataService } from '../../services/modal-data.service';
import { MySynchConstantService } from '../../services/mysynch.constant.service';
import { PerformanceMetricsService } from '../../services/performance-metrics.service';
import { PerformanceContextService } from '../../services/performance-context.service';
import { PerformanceContext } from '../../interfaces/mysynch.interfaces';

@Component({
  standalone: false,
  selector: 'no-metadata-date-modal',
  templateUrl:"../app/modals/no-metadata-date-modal/no-metadata-date-modal.view.html",
  styleUrls: ["../app/modals/no-metadata-date-modal/no-metadata-date-modal.style.css"],
})
export class NoMetaDataDateModalComponent extends MysynchModalComponent implements OnInit , AfterViewInit {
  
 
  private hideNotification: boolean = false;   
  private noMetaDataDateLocalStorageTmpl: any = {personId: null ,herdId:null,expiry:null, dirty: false};
  private currentActiveHerd: any = null;
  private extendedHideNotificaitonNumDays: number = 0;
  private performanceContext: PerformanceContext | null = null;
  @Input() configuration: any = {};
  @Input() customData: any;
  @Output() closeModal = new EventEmitter<{ error: any; data: any }>(); // Emit an object with error and data properties
  

  constructor(@Inject('MySynchFactory') protected MSF: any,
              @Inject('ApiFactory') protected api: any,
              @Inject(ModalDataService) protected modalDataService: ModalDataService,
              @Inject(MySynchConstantService) protected mySynchConstantService: MySynchConstantService,
              @Inject(PerformanceMetricsService) protected perfMetricSvc: PerformanceMetricsService,
              @Inject(PerformanceContextService) protected perfContextSvc: PerformanceContextService) {
    super(MSF,api,modalDataService,mySynchConstantService,perfMetricSvc); 
  }

    private initializeModal(){
      this.title = _.get(this.configuration,'title',"Farm Data Issue");

      this.extendedHideNotificaitonNumDays = this.modalDataService.getNoMetaDataDateNumDaysExtendedHideLimit();
          
      // getting territory manager info
      var territoryManager = this.MSF.getActiveFarmTerritoryManager();

      var message = `Please contact your local Parnell Territory Manager ${_.get(territoryManager,'name')} at <a href='mailto:${_.get(territoryManager,'email')}' class='btn-link link-color text-blue-important'>${_.get(territoryManager,'email')}</a> or <a href='tel://${_.get(territoryManager,'phone')}' class='btn-link link-color text-blue-important'>${_.get(territoryManager,'phone')}</a> for help making your information current.`  
      this.message = _.get(this.configuration,'message',message);
      
      this.withBlur = _.get(this.configuration,'withBlur',this.withBlur);
      this.showModal = true; // _.get(this.configuration,'showModal',this.showModal);
    }

    ngOnInit() {
             
      this.MSF.getActiveHerdWithWait().then((activeHerd) => {
           this.performanceContext = this.perfContextSvc.createPerformanceContext(_.get(activeHerd,'herdId',null));
           this.perfMetricSvc.startTiming("Component:NoMetaDataDateModal:Render");
           this.currentActiveHerd = activeHerd;
           this.initializeModal();
        }, (error) => {
          console.log("error getting active herd in noMetaDataDateModalComponent ngOnInit()");
          // even if there is an error getting the active herd, we still want to initialize the modal
          this.initializeModal();
        });
    
    }
  ngAfterViewInit() {
       this.MSF.getActiveHerdWithWait().then((activeHerd) => {
          this.perfMetricSvc.endTiming("component","Component:NoMetaDataDateModal:Render",this.performanceContext);
      });
  }

  onConfirm() {
   
    var currentHerdId = _.get(this.MSF.getActiveHerd(),'herdId');
    var currentPersonId = _.get(this.MSF,'cookies.user.PersonId');
    var existingnoMetaDataDateExpiries = this.MSF.getParsedLocalStorageItem(this.mySynchConstantService.noMetaDataDateExpiries);

    var noMetaDataDateExpiries = [];

    if(!_.isUndefined(existingnoMetaDataDateExpiries)){
        noMetaDataDateExpiries = _.reject(existingnoMetaDataDateExpiries, function(expiryItem) { return _.isEqual(_.get(expiryItem,'herdId'),currentHerdId) && _.isEqual(_.get(expiryItem,'personId'),currentPersonId); });
    }
    // set the initial expiry to the current date at the end of the day
    //var newNoMetaDataDateExpiry = moment().endOf('day').format(this.MSF.i18n.format.dateLong);
    var newNoMetaDataDateExpiry = moment().add(1,'day').startOf('day');
    

    if(this.hideNotification){
         newNoMetaDataDateExpiry = moment().add(this.extendedHideNotificaitonNumDays,'days').startOf('day');
    }

   
   var newNoMetaDataDateExpiryItem = _.cloneDeep(this.noMetaDataDateLocalStorageTmpl);
   _.set(newNoMetaDataDateExpiryItem,'personId',currentPersonId);
   _.set(newNoMetaDataDateExpiryItem,'herdId',currentHerdId);
   
   var  newNoMetaDataDateExpiryBrowserStoredString = newNoMetaDataDateExpiry.format("YYYY-MM-DDTHH:mm:ss");
   var  newNoMetaDataDateExpiryDBStoredString  = newNoMetaDataDateExpiryBrowserStoredString + 'Z';
   _.set(newNoMetaDataDateExpiryItem,'expiry',newNoMetaDataDateExpiryBrowserStoredString);

   noMetaDataDateExpiries.push(newNoMetaDataDateExpiryItem);
   noMetaDataDateExpiries = _.sortByOrder(noMetaDataDateExpiries, ["personId","herdId","expiry"], ["asc","asc","asc"]);
   localStorage.setItem('noMetaDataDateExpiries',JSON.stringify(noMetaDataDateExpiries));
  
   var appLevelNotificationId = _.get(_.find(_.get(this.MSF,'lists.appLevelNotifications',[]),{name:this.mySynchConstantService.noMetaDataDateNotificationName}),'notificationId');
    this.api.upsertPersonAppLevelNotification(currentPersonId,currentHerdId,appLevelNotificationId,newNoMetaDataDateExpiryDBStoredString,(error,data)=>{
        if(error){
            console.log("error upserting person app level notification in noMetaDataDateModalComponent onConfirm()");
        }
    });
  
   this.closeModal.emit(_.cloneDeep(this.closeModalDataTmpl)); 
  }
  onCancel() {
    this.closeModal.emit(_.cloneDeep(this.closeModalDataTmpl)); // Just emit the event without any data
  }
}
